import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ThemeService } from './shared/services/theme.service';
import { environment } from 'src/environments/environment';
import { AppState } from './shared/stores/states/app.state';
import * as UserActions from './shared/stores/actions/user.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'RUBi';
  constructor(
    private themeService: ThemeService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    let themeName = this.themeService.getCurrentThemeName() || environment.defaultTheme;
    this.themeService.applyThemeByName(themeName);

    this.store.dispatch(UserActions.initApp());
  }


  reloadUser() {
    this.store.dispatch(UserActions.loadCurrentUser());
  }
}
